module.exports = __webpack_public_path__ + "img/ogp_abc_big.5580b12e.jpg";